/**
 * Reduces a full address label to its city: "Gentse Steenweg 243c, 9160 Lokeren, België"
 * and the Google place label "BattleKart Gent, Vliegtuiglaan, Gent, België" both give the
 * town. Partner offerings are rendered anonymously, so the street — which identifies the
 * partner — must never reach the UI.
 *
 * Best effort: with three or more segments the last is the country and the town sits just
 * before it; "Street, City" takes the second. A leading postal code is stripped. A label
 * without commas is assumed to already be a city.
 */
export function addressCityLabel(name: string | null | undefined): string | null {
    if (!name) return null;
    const segments = name.split(',').map(segment => segment.trim());
    // No comma: can't isolate a city. Reject anything with a digit (house number
    // → street) so partner-identifying street data never reaches the UI; a
    // digit-free token is assumed to already be a bare city name.
    if (segments.length < 2) return /\d/.test(name) ? null : name;
    const town = segments[segments.length > 2 ? segments.length - 2 : 1];
    if (!town) return null;
    // Strip a leading BE ("9160") or NL ("1234 AB") postal code.
    return town.replace(/^\d{4}\s*(?:[A-Z]{2}\s+)?/, '').trim() || town;
}
